/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HelpTicketGameHealthFailingFeature
 */
export interface HelpTicketGameHealthFailingFeature {
    /**
     * 
     * @type {string}
     * @memberof HelpTicketGameHealthFailingFeature
     */
    feature: string;
    /**
     * 
     * @type {number}
     * @memberof HelpTicketGameHealthFailingFeature
     */
    eventCount: number;
}

/**
 * Check if a given object implements the HelpTicketGameHealthFailingFeature interface.
 */
export function instanceOfHelpTicketGameHealthFailingFeature(value: object): value is HelpTicketGameHealthFailingFeature {
    if (!('feature' in value) || value['feature'] === undefined) return false;
    if (!('eventCount' in value) || value['eventCount'] === undefined) return false;
    return true;
}

export function HelpTicketGameHealthFailingFeatureFromJSON(json: any): HelpTicketGameHealthFailingFeature {
    return HelpTicketGameHealthFailingFeatureFromJSONTyped(json, false);
}

export function HelpTicketGameHealthFailingFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): HelpTicketGameHealthFailingFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'feature': json['feature'],
        'eventCount': json['eventCount'],
    };
}

export function HelpTicketGameHealthFailingFeatureToJSON(json: any): HelpTicketGameHealthFailingFeature {
    return HelpTicketGameHealthFailingFeatureToJSONTyped(json, false);
}

export function HelpTicketGameHealthFailingFeatureToJSONTyped(value?: HelpTicketGameHealthFailingFeature | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feature': value['feature'],
        'eventCount': value['eventCount'],
    };
}

